module.exports = "/assets/js/4a94388729a56c13c49c506479e031bc.svg";